import type { ChangelogEntry } from "../types";

/**
 * VIB-2766. Saldoen synlig for ledere, og RLS på timebank.
 *
 * Saldo-punktene er admin-seksjonen: `role_menu_permissions` gir bare admin og
 * superadmin `timebank`, og Ansatte-siden er også admin-only. Et punkt uten
 * rollekrav ville fortalt ansatte om skjermer de ikke kan åpne.
 *
 * Punktet om at egne kansellerte rader forsvinner gjelder ALLE, og står derfor
 * i en egen seksjon uten rollekrav: det er den ene endringen en vanlig ansatt
 * faktisk kan se.
 */
export const TIMEBANK_SALDO_2026_10: ChangelogEntry = {
  id: "2026-10-05-timebank-saldo",
  date: "2026-10-05",
  title: "Timebank-saldo synlig for ledere",
  summary:
    "Den som godkjenner et uttak ser nå hva søkeren har på saldo, og hver ansatt har fått en Timebank-fane på profilen sin.",
  sections: [
    {
      heading: "Timebank",
      minRole: "admin",
      items: [
        {
          title: "Saldoen står i godkjenningslista",
          kind: "nytt",
          body: "Under hver søknad ser du nå saldoen til den som har søkt, ved siden av kapasitet og fravær. Før måtte du gjette eller slå det opp et annet sted, og et uttak kunne bli godkjent uten at noen visste om det var dekning for det.",
        },
        {
          title: "Egen Timebank-fane på ansattprofilen",
          kind: "nytt",
          body: "Under Ansatte, inne på en person, finner du saldo, hva som venter til behandling, og hele historikken for den ene ansatte. Fanen viser, den endrer ikke: godkjenning og avslag gjør du fortsatt på Timebank-siden.",
        },
        {
          title: "Samme tall som den ansatte selv ser",
          kind: "nytt",
          body: "Saldoen regnes ut på én måte, og brukes både på ansattens eget kort og på de to nye stedene. To steder som regner ut det samme tallet hver for seg blir før eller senere uenige, og da stoler ingen på noen av dem.",
        },
      ],
    },
    {
      heading: "Overalt i Revehiet",
      items: [
        {
          title: "Timebanken din er bare din",
          kind: "forbedret",
          body: "Databasen håndhever nå at du bare ser dine egne timebank-rader. Før lå den grensen i skjermbildet, og det er en forskjell som betyr noe: nå er det ikke mulig å komme rundt den, uansett vei inn. Ledere ser fortsatt alle, som før.",
        },
        {
          title: "Fjernede søknader er borte, ikke bare skjult",
          kind: "forbedret",
          body: "Har en leder fjernet en av dine søknader, forsvinner den fra historikken din. Den er fortsatt sporet i loggen, så ingenting går tapt for de som skal kunne se tilbake.",
        },
        {
          title: "«Fjernet» heter det samme overalt",
          kind: "rettet",
          body: "En fjernet søknad sto som «Kansellert» på ditt eget kort og «Fjernet» i lederens oversikt. Nå heter det det samme begge steder, så det er lettere å se at det er snakk om det samme.",
        },
      ],
    },
  ],
};
